import { render, staticRenderFns } from "./PromotionButtons.vue?vue&type=template&id=0cc6f176&scoped=true"
import script from "./PromotionButtons.vue?vue&type=script&lang=js"
export * from "./PromotionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc6f176",
  null
  
)

export default component.exports